import { createSelector } from 'reselect'

const selector = state => state.allLoadsReducer

export const allLoadFilterSelector = createSelector(
  [selector],
  ({ filters }) => filters
)

export const allLoadLoadMoreSelector = createSelector(
  [selector],
  ({ loadMore }) => loadMore
)

export const allLoadLoadPageSelector = createSelector(
  [selector],
  ({ loadPage }) => loadPage
)

export const allLoadErrorSelector = createSelector(
  [selector],
  ({ error }) => error
)

export const allLoadLoadsSelector = createSelector(
  [selector],
  ({ loads }) => loads
)

export const allLoadNoMoreSelector = createSelector(
  [selector],
  ({ noMore }) => noMore
)

export const allLoadSelector = createSelector(
  [selector],
  allLoads => allLoads
)
